import React, { Component } from 'react'
import { connect } from 'react-redux'
import { last } from '../utils'
import config from '../config'
import News from './News'
import ContentService from '../services/content'
import Section from '../components/Section/Section'
import { __ } from '../services/translate'
import Article from '../components/Article/Article'
import { CONTENT_CHANGED, CONTENT_LEAVE } from '../constants/content'
import bus from '../services/bus'
import { selectLicenceNumbers } from '../utils/selectors/content'
import Loader from '../components/Common/Loader'

class ContentResolver extends Component {

  state = {
    shouldShowArticle: false,
    shouldShowSection: false,
    error: null,
    article: null,
    section: null,
    articlesInSection: null,
    homepage: false,
  }

  componentDidMount() {
    this.setState(ContentResolver.resolve(this.props))
    bus.emit(CONTENT_CHANGED)
  }

  componentWillUnmount() {
    ContentService.clear()
    bus.emit(CONTENT_LEAVE)
  }

  static getDerivedStateFromProps(props) {
    const state =  ContentResolver.resolve(props)
    bus.emit(CONTENT_CHANGED)
    return state
  }

  static resolve = (props) => {
    // parse url
    const { url } = props.match

    let parsedUrl
    try {
      parsedUrl = ContentService.parseUrl(url)
    } catch (e) {
      if (url !== '/') {
        props.history.push('/')
        return null
      }
    }

    if (ContentService.shouldShowArticle(url)) {
      try {
        // find and load article from tree
        const article = ContentService.findArticle(parsedUrl.articles, props.articles, {
          vehicleType: props.selectedVehicleType,
          country: props.selectedCountry,
          userLicences: props.userLicences
        })
        return {
          article,
          shouldShowArticle: true,
          shouldShowSection: false,
          homepage: false,
        }
      } catch (e) {
        return { error: true }
      }
    } else if (ContentService.shouldShowSection(url)) {
      try {
        // find and load section from tree
        const section = ContentService.findSection(
          parsedUrl.sections,
          props.selectedLanguage.slug,
          props.sections
        )
        // find and load section's articles
        const articlesInSection = ContentService.getArticlesForSection(
          last(parsedUrl.sections),
          props.articles,
          props.selectedLanguage.id,
          props.userLicences
        )

        return {
          section,
          articlesInSection,
          shouldShowSection: true,
          shouldShowArticle: false,
          homepage: false,
        }
      } catch (e) {
        return { error: true }
      }
    } else if (url === '/') {
      return { homepage: true }
    } else {
      return { error: true }
    }
  }

  render() {

    if (this.props.loading || this.props.articles.length === 0 || this.props.sections.length === 0) {
      return <Loader/>
    }

    // show news on homepage
    if (this.state.homepage) {
      return <News {...this.props}/>
    }

    // show article
    if (this.state.shouldShowArticle) {
      return <Article article={this.state.article} documents={this.props.documents}/>
    }

    // show section
    if (this.state.shouldShowSection) {
      // check if it's news section
      if (this.state.section.id === config.newsSectionId) {
        return <News {...this.props}/>
      }

      return (
        <Section
          section={this.state.section}
          articles={this.state.articlesInSection}
          redirect={this.props.history.push}
        />
      )
    }

    // otherwise show 404
    return (
      <h1>404 - {__('Stránka nenalezena')}</h1>
    )
  }
}

const mapStateToProps = (state) => ({
  sections: state.content.sections,
  articles: state.content.articles,
  selectedLanguage: state.locale.selectedLanguage,
  selectedCountry: state.locale.selectedCountry,
  selectedVehicleType: state.user.selectedVehicleType,
  documents: state.user.documents,
  userLicences: selectLicenceNumbers(state.user),
  loading: state.content.loading
})

export default connect(mapStateToProps)(ContentResolver)
